<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="Logo">
      </div>
      <div class="status-content">
        <div v-if="!error" class="status-state">
          <a-spin size="large" />
          <p class="status-text">正在跳转至授权中心...</p>
        </div>
        <div v-else class="status-state">
          <a-icon type="close-circle" theme="twoTone" two-tone-color="#ff4d4f" class="status-icon" />
          <p class="status-text">{{ errorMsg }}</p>
          <a-button type="primary" class="mt-20" @click="login">重试</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { metaInfo } from '@/utils/mixin'
import { getOAuthUrl } from '@/api/login/login'

export default {
  name: 'Login',

  mixins: [metaInfo],

  props: {
    from: {
      type: String,
      default: '/'
    }
  },

  data() {
    return {
      error: false,
      errorMsg: ''
    }
  },

  mounted() {
    this.login()
  },

  methods: {
    async login() {
      this.error = false

      try {
        const { success, result, message } = await getOAuthUrl()

        if (success) {
          const base = `${window.location.protocol}//${window.location.host}`
          const redirect = `${base}/callback?from=${encodeURIComponent(this.from)}`
          const url = `https://openatom.cn/trivial-services/oauth-transfer-platform/index/main?oauth_uri=${encodeURIComponent(result)}&redirect_uri=${encodeURIComponent(redirect)}`

          window.location.replace(url)
        } else {
          this.error = true
          this.errorMsg = message || '获取授权地址失败'
        }
      } catch (e) {
        this.error = true
        this.errorMsg = '网络错误，请稍后重试'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background: #f0f2f5 url("~@/assets/images/bg.jpg") center center / cover no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.auth-card {
  width: 400px;
  padding: 48px 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  text-align: center;

  .logo {
    margin-bottom: 40px;
    img {
      height: 52px;
      width: auto;
    }
  }

  .status-content {
    min-height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .status-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .status-icon {
    font-size: 56px;
    margin-bottom: 24px;
  }

  .status-text {
    margin-top: 20px;
    font-size: 16px;
    color: #666;
    line-height: 1.6;
  }

  .mt-20 {
    margin-top: 24px;
    height: 40px;
    padding: 0 32px;
    border-radius: 20px;
    font-size: 15px;
  }
}
</style>
